import { render } from "./MailDeliverySettings.vue?vue&type=template&id=c899f076&scoped=true&ts=true"
import script from "./MailDeliverySettings.vue?vue&type=script&lang=ts"
export * from "./MailDeliverySettings.vue?vue&type=script&lang=ts"

import "./MailDeliverySettings.vue?vue&type=style&index=0&id=c899f076&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c899f076"]])

export default __exports__